const binding = { modules: {}, dataActions: {} };

    (binding.modules['cus-cancellation-form'] = {
        c: () => require('partner/modules/cus-cancellation-form/cus-cancellation-form.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'cus-cancellation-form',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/cus-cancellation-form'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };